<template>
  <div>
    Page d'accueil !
  </div>
</template>

<script>


export default {
  name: 'home',
  data () {
    return{
    }
  },
  mounted:function(){
    this.$nextTick(function () {
    })
  },
  methods:{

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// home.vue?783413ec